<template>
  <div class="userSegment">
    <el-popover
      placement="bottom-end"
      width="450"
      trigger="click"
      popper-class="notify-popover"
      v-model="showNotify"
      v-if="!isAdmin"
    >
      <div class="notify">
        <div
          class="header font-weight__bold font-size__small flex-row flex__between"
        >
          Thông báo
        </div>
        <VuePerfectScrollbar
          class="scroll-area"
          :settings="perfectScrollbarSetting"
          infinite-wrapper
        >
          <div class="body">
            <div
              :class="[
                'ele-notify flex-row clickable',
                item.status === 'unSeen' ? 'read' : '',
              ]"
              v-for="item in listNotify"
              :key="item.id"
            >
              <notify-content
                @hideNotify="showNotify = false"
                :item="item"
              ></notify-content>
            </div>
            <infinite-loading
              ref="infiniteLoading"
              spinner="spiral"
              @infinite="infiniteHandler"
              force-use-infinite-wrapper=".el-table__body-wrapper"
            >
              <div slot="no-more"></div>
              <div slot="no-results">Không có dữ liệu</div>
            </infinite-loading>
          </div>
        </VuePerfectScrollbar>
      </div>
      <div
        slot="reference"
        class="btnIcon notifyToggler clickable margin-right-10"
      >
        <el-badge is-dot>
          <i class="fas fa-bell"></i>
        </el-badge>
      </div>
    </el-popover>

    <el-popover
      placement="bottom-start"
      trigger="click"
      popper-class="user-popover"
    >
      <div class="menu-user">
        <div class="profile">
          <div class="metaInfo">
            <div class="item">
              <!-- <i class="fas fa-user color__link margin-right-10"></i> -->
              <div class="user1"></div>
              <span>&nbsp;{{ user ? user.fullName : "---" }}</span>
            </div>

            <div class="item">
              <!-- <i class="fas fa-mobile color__link margin-right-10"></i> -->
              <div class="user2"></div>
              <span>&nbsp;{{ loadUserDeptRoles }}</span>
            </div>

            <!-- <div class="item">
              <i class="fas fa-mobile color__link margin-right-10"></i>
              <span>&nbsp;<a target="_blank" href="https://drive.google.com/drive/folders/1G33ClFkCT_h_k9WoD-cwxLXHKoxHdR4J">Văn bản mẫu</a></span>
            </div> -->

            <!-- <div class="item">
              <i class="fas fa-envelope color__link margin-right-10"></i>
              <span>{{ user ? user.email : "---" }}</span>
            </div> -->

            <div
              class="item clickable"
              @click="$router.push({ name: 'profileManagement' })"
            >
              <!-- <i class="fas fa-cog color__link margin-right-10"></i> -->
              <div class="user3"></div>
              <span>Cài đặt</span>
            </div>

            <div class="item clickable" @click="viewSupportInfo">
              <!-- <i class="fas fa-question color__link margin-right-10"></i> -->
              <div class="user4"></div>
              <span>Hỗ trợ</span>
            </div>

            <div class="item clickable" @click="logout">
              <!-- <i class="fas fa-sign-out-alt color__link margin-right-10"></i> -->
              <div class="user5"></div>
              <span>Đăng xuất</span>
            </div>
          </div>
        </div>

        <!-- <el-button
          size="mini"
          class="btnSolid__blue"
          @click="$router.push({ name: 'profileManagement' })"
        >
          &nbsp;Quản lý profile
        </el-button>

        <el-button size="mini" class="btnSolid__blue">
          <i class="fas fa-sign-out-alt"></i>
          &nbsp;Đăng xuất
        </el-button> -->
      </div>

      <div slot="reference" class="profile clickable">
        <div
          class="thumbnail flex-row flex__center"
          :style="setBackground"
        ></div>
        <div class="txt">
          <span class="name no_wrap"
            >{{ user ? user.fullName : "" }}</span
          >
          <span class="role">{{ user ? user.mobile : "" }}</span>
        </div>
      </div>

      <support
        :isOpen="isOpenDialogSupportInfo"
        @closeDialog="isOpenDialogSupportInfo = false"
      />

      <!-- <i slot="reference" class="fas fa-caret-down clickable"></i> -->
    </el-popover>
  </div>
</template>

<script>
import vbNotificationService from "../../services/vbNotificationService";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import h from "../../services/h";
import NotifyContent from "./notify-content";
import InfiniteLoading from "vue-infinite-loading";
import constants from "../../constants.js";
import Support from "./support.vue";

export default {
  name: "user-header",

  components: {
    NotifyContent,
    VuePerfectScrollbar,
    InfiniteLoading,
    support: () => import("./support"),
    Support,
  },
  computed: {
    isAdmin() {
      return (
        this.$store.getters.userDeptRole &&
        this.$store.getters.userDeptRole.roleCode === constants.ROLE.CODE.ADMIN
      );
    },
    user() {
      return this.$store.getters.user;
    },
    listNotify() {
      return this.$store.getters.notifies;
    },
    notificationsUnreadCount() {
      return "";
    },
    setBackground() {
      if (this.$store.getters.user && this.$store.getters.user.iconPhoto) {
        return {
          "background-image": "url(" + this.$store.getters.user.iconPhoto + ")",
        };
      }
    },
    loadUserDeptRoles() {
      if(this.$store.getters.userDeptRoles) {
        let currentRole = this.$store.getters.userDeptRoles.filter(item => item.status === constants.USER_DEPT_ROLE.STATUS.ACTIVE);
        return currentRole && currentRole[0] && (currentRole[0].positionName + " " + currentRole[0].deptName);
      }
      return "";
    },
  },
  methods: {
    infiniteHandler($state) {
      this.list().then((items) => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    list() {
      let pageable = {
        page: this.page,
        size: this.size,
        sort: "createTime,desc",
      };

      return vbNotificationService.findAll(pageable).then((response) => {
        let items = response.data;
        items && this.$store.commit("loadMore", items);
        return items;
      });
    },

    countUnSeen() {
      let count = 0;
      h.each(this.listNotify, function (item) {
        if (item.status === "unSeen") count++;
      });
      return count;
    },

    logout() {
      this.$router.push({ name: "logout" });
    },

    viewSupportInfo() {
      this.isOpenDialogSupportInfo = !this.isOpenDialogSupportInfo;
    },

    goToDashBoard() {
      this.$router.push({
        name: "dashboard",
      });
    },
  },
  data() {
    return {
      perfectScrollbarSetting: { maxScrollbarLength: 350 },
      pageable: { page: 0, size: 10, sort: "createTime,desc" },
      page: 1,
      size: 10,
      showNotify: false,
      isOpenDialogSupportInfo: false,
    };
  },
};
</script>

<style scoped>
.scroll-area {
  max-height: 500px;
  height: auto;
  width: 100%;
  position: relative;
  margin: auto;
}

.userSegment {
  color: var(--color-dark-cerulean);
  display: flex;
  align-items: center;
  line-height: initial;
  z-index: 2;
  margin-right: 24px;
  width: 270px;
  flex: 0 0 auto;
  justify-content: flex-end;
}

.userSegment .notifyToggler {
  margin-right: 24px;
  cursor: pointer;
}

.userSegment .notifyToggler i {
}

.userSegment .notifyToggler .el-badge {
}

.userSegment .profile {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.profile .thumbnail {
  width: 32px;
  height: 32px;
  /*background-color: rgba(0, 0, 0, 0.5);*/
  border-radius: 50%;
  flex: 0 0 auto;
  margin-right: 6px;
  /*border: 1px solid rgba(255, 255, 255, 0.4);*/
  background-image: url("../../assets/icon-user.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.user1 {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  background-image: url("../../assets/1.svg");
  background-repeat: no-repeat;
  background-position: center;
}

.user2 {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  background-image: url("../../assets/2.svg");
  background-repeat: no-repeat;
  background-position: center;
}

.user3 {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  background-image: url("../../assets/3.svg");
  background-repeat: no-repeat;
  background-position: center;
}

.user4 {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  background-image: url("../../assets/4.svg");
  background-repeat: no-repeat;
  background-position: center;
}

.user5 {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  background-image: url("../../assets/5.svg");
  background-repeat: no-repeat;
  background-position: center;
}

.userSegment .profile .txt {
}

.userSegment .profile .txt .name {
  display: block;
  font-weight: 600;
}

.userSegment .profile .txt .role {
  font-size: 12px;
  color: var(--color-smoke);
}

.btnIcon {
  text-align: center;
  margin-right: 20px;
}

.option.clickable:hover i {
  transform: scale(1.1);
  transition: var(--transition-regular);
}

.menu-user .profile {
  margin: 0;
  text-align: center;
}

.menu-user .profile .thumbnail {
  margin: 0 auto;
}

.menu-user .profile .name {
  margin: 8px 0;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
}

.menu-user .profile .metaInfo {
  margin-bottom: 12px;
}

.menu-user .profile .metaInfo .item {
  display: flex;
  align-items: center;
}

.menu-user .profile .metaInfo .item i {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-user .profile .metaInfo .item span {
  border-bottom: 1px solid var(--color-light);
  width: 100%;
  text-align: left;
  padding: 8px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/header/user-header.vue